import React from "react";
import SponsorCard from "./SponsorCard";
import { useSponsors } from "../api/selectors";

interface Props {
  level: number;
}

const SponsorRow = ({ level }: Props) => {
  const sponsors = useSponsors(level);

  return (
    <div className="partnerRow">
      {sponsors.map((sponsor) => (
        <SponsorCard key={sponsor.url} sponsor={sponsor} />
      ))}
      <style jsx>{`
        .partnerRow {
          display: flex;
          flex-wrap: wrap;
          max-width: 1050px;
          margin: 0 0 40px;
        }
      `}</style>
    </div>
  );
};

export default SponsorRow;
